import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "size"];
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var IconInformation20pxBlodS = function IconInformation20pxBlodS(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color
  }, otherProps), {}, {
    viewBox: "0 0 20 20",
    children: [/*#__PURE__*/_jsx("path", {
      opacity: ".1",
      d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10z",
      fill: "#FF7028"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.82 8.78a3.18 3.18 0 116.358 0v1.849l.61.905a.629.629 0 01-.52.98H6.73a.629.629 0 01-.522-.98l.611-.905v-1.85zm4.45 4.363H8.727c0 .694.563 1.257 1.257 1.257h.03c.694 0 1.256-.563 1.256-1.257z",
      fill: "#FF7028"
    })]
  }));
};
export default IconInformation20pxBlodS;